export function queryGeomByAttr(queryUrl,queryName,attrs,geom) {
  let geojson

  let graphic = new mars3d.graphic.PolygonEntity({
    positions: geom.pointArry,
    style:geom.style
  })
  
  let queryMapServer = new mars3d.query.QueryGeoServer({
    // url:"http://192.168.1.16:9090/geoserver/wfs",
    url: queryUrl + "/wfs",
    layer:queryName
  })

  let columns = []
  for(let key in attrs){
    columns.push(key)
  }
  let filter = ""
  for(let i = 0;i<columns.length;i++){
    filter += `${columns[i]}='${attrs[columns[i]]}'`
    if(i != columns.length - 1){
      filter += ' and '
    }
  }
  return new Promise(resolve => {

    queryMapServer.queryBySql({
      cql_filter:filter,
      graphic:graphic,
      geometryName:'geom',
      success: (result) => {
        if (result.count === 0) {
          return
        }
        geojson = result
        resolve(geojson)
      },
      error: (error) => {
        console.log('访问错误',error);
        return
      }
    })
  })

}